import {AutoRefreshTokenService, provideKeycloak, UserActivityService, withAutoRefreshToken} from "keycloak-angular";
import {environment} from "../../../environments";

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.keycloak.url,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId,
    },
    initOptions: environment.backend === "OpenEMS Backend" ? { // only use keycloak with portal
      onLoad: "login-required",
      silentCheckSsoRedirectUri: window.location.origin + "/assets/silent-check-sso.html",
      redirectUri: window.location.href,
    } : undefined,
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: "none",
        sessionTimeout: 60000,
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,

    ],
  });
